import React from 'react';

import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import StoreLocationIcon from '~/icons/components/StoreLocationIcon';
import useDefaultStoreLocation from '~/shared/utils/useDefaultStoreLocation';
import { Section } from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

const StoreLocationSection = styled(Section)`
  line-height: 1.2;
  white-space: nowrap;
  text-align: left;

  & > div:first-child {
    font-weight: 700;
  }
`;

const Location = styled.div`
  font-weight: 600;
  line-height: 1.4;

  ${({ $hasUrl }) =>
    $hasUrl &&
    css`
      &:hover {
        font-weight: 700;
        text-decoration: underline;
      }
    `};
`;

const LocationLabelContainer = styled.div`
  white-space: nowrap;
  & > span {
    line-height: 1.4;
    font-weight: 600;

    ${({ $hasUrl }) =>
      $hasUrl &&
      css`
        &:hover {
          font-weight: 700;
          text-decoration: underline;
        }
      `};
  }
`;

function Stores({ hasUrl }) {
  const { defaultStore, hasLocation } = useDefaultStoreLocation();

  return (
    <>
      <StoreLocationIcon size={14} />
      <StoreLocationSection>
        {hasLocation ? (
          <Location $hasUrl={hasUrl}>
            {defaultStore.address.city}, {defaultStore.address.state}
          </Location>
        ) : (
          <LocationLabelContainer $hasUrl={hasUrl}>
            <FormattedMessage
              id="site_navigation.no_store_selected"
              defaultMessage="Our Stores"
            />
          </LocationLabelContainer>
        )}
      </StoreLocationSection>
    </>
  );
}

Stores.propTypes = {
  hasUrl: PropTypes.bool,
};

export default Stores;
